import { StandardEvents } from '@shopify/events';
// Savor owns variant resolution, recipient state, validation rules and cart requests.
// This wrapper prevents submission during resolution and clears stale presentation.
class FDGiftCard extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    document.addEventListener('scroll', () => this.updateChatPosition(), { ...options, passive: true, capture: true });
    window.addEventListener('resize', () => this.updateChatPosition(), options);
    this.updateChatPosition();
    this.addEventListener('input', () => this.resetSuccess(), options);
    this.addEventListener('change', () => this.resetSuccess(), options);
    this.addEventListener('recipient:toggle', () => this.resetSuccess(), options);
    this.addEventListener('submit', event => {
      const purchase = this.querySelector('fd-product-purchase');
      if (this.resolving || this.variantFailed || purchase?.pending || !event.target.reportValidity()) {
        event.preventDefault(); event.stopImmediatePropagation();
      }
    }, { ...options, capture: true });
    this.addEventListener(StandardEvents.cartLinesUpdate, event => {
      if (event.action !== 'add' || !this.contains(event.target)) return;
      // Native FormData has already captured the configuration at this point.
      const controls = [...this.querySelectorAll('variant-picker input, .recipient-form input:not([type=hidden]), .recipient-form textarea, quantity-selector-component input, quantity-selector-component button')];
      const disabled = controls.map(control => control.disabled);
      controls.forEach(control => { control.disabled = true; });
      this.setAttribute('aria-busy', 'true');
      event.promise.catch(() => {}).finally(() => queueMicrotask(() => {
        if (!this.isConnected) return;
        controls.forEach((control, index) => { control.disabled = disabled[index]; });
        this.setAttribute('aria-busy', 'false');
      }));
    }, options);
    this.addEventListener(StandardEvents.productSelect, event => {
      if (!this.contains(event.target)) return;
      const generation = this.generation = (this.generation || 0) + 1;
      this.resolving = true; this.variantFailed = false; this.resetSuccess();
      this.querySelector('[ref=addToCartButton]').disabled = true;
      this.setAttribute('aria-busy', 'true');
      event.promise.then(({ detail }) => {
        queueMicrotask(() => {
          if (!this.isConnected || generation !== this.generation) return;
          this.resolving = false; this.setAttribute('aria-busy', 'false');
          const button = this.querySelector('[ref=addToCartButton]');
          const source = detail?.html?.querySelector('product-form-component [ref=addToCartButton]');
          const purchase = this.querySelector('fd-product-purchase');
          const sourcePurchase = detail?.html?.querySelector('fd-product-purchase');
          purchase.dataset.saleBlocked = sourcePurchase?.dataset.saleBlocked || 'true';
          if (sourcePurchase) purchase.dataset.unavailable = sourcePurchase.dataset.unavailable;
          button.disabled = !source || source.disabled || purchase.dataset.saleBlocked === 'true';
          button.setAttribute('data-puppet', 'true');
        });
      }).catch(error => {
        if (generation !== this.generation || !this.isConnected) return;
        this.resolving = false; this.variantFailed = true; this.setAttribute('aria-busy', 'false');
        if (error.name !== 'AbortError') {
          const purchase = this.querySelector('fd-product-purchase');
          purchase.dataset.state = 'error'; purchase.status(purchase.dataset.error);
        }
      });
    }, options);
  }
  updateChatPosition() {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      const mobile = matchMedia('(max-width: 63.999em)').matches;
      const anchor = this.querySelector(mobile ? '.fd-gift__mobile-value' : '.fd-gift__configuration');
      const rect = anchor.getBoundingClientRect();
      const top = parseFloat(getComputedStyle(anchor).top) || 0;
      const visible = rect.bottom > top && rect.top < (mobile ? innerHeight - rect.height : 120);
      this.dataset.configuring = String(visible);
      if (mobile && visible) document.body.style.setProperty('--fd-gift-chat-top', `${Math.max(rect.top, top) + 8}px`);
    });
  }
  resetSuccess() {
    const purchase = this.querySelector('fd-product-purchase');
    if (purchase?.dataset.state !== 'success') return;
    purchase.dataset.state = 'idle'; purchase.status('');
    purchase.querySelector('product-form-component > [ref=liveRegion]').textContent = '';
  }
  disconnectedCallback() { this.abort?.abort(); cancelAnimationFrame(this.frame); this.frame = null; document.body.style.removeProperty('--fd-gift-chat-top'); }
}
if (!customElements.get('fd-gift-card')) customElements.define('fd-gift-card', FDGiftCard);
